import React, {Component, Fragment} from 'react'
import StyleSheet from 'styles'
import {FormContext, Stages, StyledForm, Select} from 'components'
import {Project, Documents, Legal, Marketing} from './deal_info'
import {InputDialog, ConfirmationDialog} from 'components'
import {Authorization} from 'utils'
import {DialogHandler} from 'utils/handlers'
import StagesReview from 'components/StagesReview'
import Button from '@material-ui/core/Button'
import SaveIcon from '@material-ui/icons/Save'

export class DealForm extends Component {
  state = {stage: -1, stages: []}
  eventReasonDialogHandler = new DialogHandler(this, 'eventReasonDialog')
  createDialogHandler = new DialogHandler(this, 'createDialog')

  componentDidMount = async() => {
    const {dealSheet} = this.props
    if (!dealSheet.id || !dealSheet.typeOfIssuance || (dealSheet.typeOfIssuance !== 'utility' && !dealSheet.dealRound)) {
      if (await this.createDialogHandler.show() === undefined)
        this.props.onCancel()
    }
  }

  get canSave() {
    return Authorization.admin || this.props.dealSheet.status === 'draft'
  }

  get dealStatus() {
    return this.props.dealSheet.status
  }

  get submitEvent() {
    return Authorization.admin ? adminActions[this.dealStatus] : issuerActions[this.dealStatus]
  }

  get rejectEvent() {
    return Authorization.admin && rejectActions[this.dealStatus]
  }

  get saveLabel() {
    return this.dealStatus === 'draft' ? 'Save Draft' : 'Update'
  }

  get legalTabName() {
    return this.props.dealSheet.typeOfIssuance === 'utility' ? 'Legal' : 'Legal/Compliance'
  }

  handleNext = () => {
    this.handleStageChange(this.state.stage + 1, this.state.stages)
  }

  handleStageChange = (stage, stages) => {
    this.props.onSave()
    this.setState({stage, stages})
  }

  handleSave = (event, isRejection) => async() => {
    this.validateRef.validate()
    const reason = isRejection ? await this.eventReasonDialogHandler.show() : undefined
    if (isRejection && !reason)
      return
    this.props.onSave(event, reason)
  }

  renderEventButtons = () =>
    <Fragment>
      {this.submitEvent &&
        <Button variant="contained" color="primary" onClick={this.handleSave(this.submitEvent)}>
          {eventLabels[this.submitEvent]}
        </Button>
      }
      {this.rejectEvent &&
        <Button variant="contained" color="primary" onClick={this.handleSave(this.rejectEvent, true)}>
          {eventLabels[this.rejectEvent]}
        </Button>
      }
    </Fragment>

  render = () => {
    const {stage, stages} = this.state
    const {
      dealSheet, errors, onChange,
      services, currencies, countries, countryGroups, accountProvider
    } = this.props

    return (
      <StyledForm className={styles.form}>
        <Stages context={dealSheet} actions={this.formActions} errors={errors} onChange={onChange}
                stage={stage} onStageChange={this.handleStageChange} validateRef={ref => this.validateRef = ref}>
          <Project services={services} accountProvider={accountProvider} currencies={currencies}/>
          <Legal countries={countries} groups={countryGroups}
                 name={this.legalTabName} title={this.legalTabName + ' information'}/>
          <Marketing optional/>
          <Documents/>
          <StagesReview/>
        </Stages>
        <InputDialog title="Request Info" label="Details" {...this.eventReasonDialogHandler.props} valueRequired/>
        <ConfirmationDialog title='Deal Type and Round' confirmLabel='Continue' {...this.createDialogHandler.props}>
          <FormContext context={dealSheet} onChange={onChange}>
            <Select member='typeOfIssuance' options={types} className={styles.select}/>
            {dealSheet.typeOfIssuance !== 'utility' && dealSheet.typeOfIssuance !== 'product' &&
              <Select member='dealRound' options={rounds} className={styles.select}/>
            }
          </FormContext>
        </ConfirmationDialog>

        {this.props.dirty && this.canSave &&
        <div className={styles.stickyContainer}>
          <Button variant='fab' color='primary' onClick={this.handleSave()}><SaveIcon/></Button>
        </div>
        }

        {this.canSave &&
          <Button variant="contained" color="secondary" onClick={this.handleSave()}>{this.saveLabel}</Button>
        }
        {stage === stages.length - 1 ?
          this.renderEventButtons()
          :
          <Button variant="contained" color="primary" onClick={this.handleNext}>Next</Button>
        }

      </StyledForm>
    )
  }
}

const rounds = [
  {value: 'seed', label: 'Seed'},
  {value: 'series_a', label: 'Series A'},
  {value: 'series_b', label: 'Series B'},
  {value: 'series_c', label: 'Series C'},
  {value: 'series_d', label: 'Series D'},
  {value: 'series_e', label: 'Series E'},
]

const types = [
  {value: 'product', label: 'Product'},
  {value: 'utility', label: 'Utility Token'},
  {value: 'security', label: 'Security Token'},
  {value: 'equity', label: 'Equity'},
]

const adminActions = {
  draft: 'approve',
  pending_review: 'approve',
  approved: 'publish'
}

const issuerActions = {
  draft: 'submit_for_review',
}

const rejectActions = {
  pending_review: 'send_to_draft'
}

const eventLabels = {
  submit_for_review: 'Submit',
  approve: 'Approve',
  publish: 'Publish',
  send_to_draft: 'Request Info',
}

const styles = StyleSheet({
  form: {
    '& a': {
      '&:not([target=_blank])': {
        color: '#6AAEAA',
        fontWeight: 'bold',
        float: 'right',
        padding: 10,
        textDecoration: 'none',
      }
    },
    '& > button': {
      width: 266,
      marginRight: 20,
      marginBottom: 20,
    }
  },
  stickyContainer: {
    position: 'sticky',
    bottom: 44,
    textAlign: 'right',
    width: '100%',
    zIndex: 1100,
    '@media(min-width: 768px)': {
      bottom: 100,
      marginTop: -8,
      height: 8,
    }
  },
  select: {
    marginTop: 10,
  },
})